/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const RemoveColumnIcon = /*#__PURE__*/ createSvgIcon(
  'RemoveColumnIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.94 16.56c.294.293.647.44 1.06.44h11a1.45 1.45 0 001.06-.438c.293-.291.44-.644.44-1.058v-.752a.723.723 0 00-.219-.536.732.732 0 00-.535-.216.714.714 0 00-.532.219.736.736 0 00-.214.535v.746h-4.75v-11H15v.75c0 .213.073.39.219.534a.734.734 0 00.535.216.714.714 0 00.532-.219.737.737 0 00.214-.536v-.749a1.44 1.44 0 00-.44-1.056A1.446 1.446 0 0015 3H4c-.413 0-.766.147-1.06.44-.293.294-.44.648-.44 1.06v11c0 .412.147.766.44 1.06zM4 4.5h4.75v11H4v-11z"
            fill="currentColor"
          />
          <path
            d="M14 10.75a.728.728 0 01-.534-.214.72.72 0 01-.216-.532c0-.21.072-.39.216-.535A.72.72 0 0114 9.25h3.5c.212 0 .39.071.534.214a.72.72 0 01.216.532c0 .21-.072.39-.216.535a.72.72 0 01-.534.219H14z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default RemoveColumnIcon;
